import * as React from 'react';
import {SVGProps} from 'react';
export const CrossIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={6}
    height={6}
    fill="none"
    {...props}>
    <path
      fill="#fff"
      d="M3 3.53 1.399 5.132a.36.36 0 0 1-.266.105.36.36 0 0 1-.37-.37.36.36 0 0 1 .105-.266L2.47 3 .868 1.399a.36.36 0 0 1-.106-.266.36.36 0 0 1 .371-.37.36.36 0 0 1 .266.105L3 2.47 4.601.868a.36.36 0 0 1 .266-.106.36.36 0 0 1 .37.371.36.36 0 0 1-.105.266L3.53 3l1.602 1.601a.36.36 0 0 1 .105.266.36.36 0 0 1-.37.37.36.36 0 0 1-.266-.105L3 3.53Z"
    />
  </svg>
);
